import {Box} from 'src/design/atoms/Box';
import {Text} from 'src/design/atoms/Text';
import React from 'react';
import {useAppSelector} from 'src/redux/hooks';
import {parseRichText} from './parseRichText';
import type {IFormFieldV2} from 'src/types/FormV2';
export interface FormViewRichTextEditorV2Props {
  field: IFormFieldV2;
  value: string;
}

export const FormViewRichTextEditorV2: React.FC<
  FormViewRichTextEditorV2Props
> = ({field, value}) => {
  const {accessToken} = useAppSelector(state => state.auth);
  return (
    <Box data-testid={`form-view-${field.name}`}>
      <Text fw={500} size="sm" c="dimmed" mb="xs">
        {field.label}
      </Text>
      <Box data-testid={`form-view-${field.name}-value`}>
        {value && parseRichText(value as string, accessToken)}
      </Box>
    </Box>
  );
};
